<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">订单管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">消息记录</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <!-- 日期 -->
                <a-range-picker :locale="locale" @change="ondateChange" />
                 <!-- 标签 -->
                <a-select style="width: 120px;margin-left:12px" allowClear @change="typehandleChange" placeholder="发送状态" :showArrow="show">
                    <a-select-option v-for="(option,x) in typeoption" :key="x" :value="option.id">
                        {{option.name}}
                    </a-select-option>
                </a-select>
                <!-- 坐席 -->
                <!-- <a-select style="width: 120px;margin-left:12px" allowClear @change="userhandleChange" placeholder="坐席" :showArrow="show">
                    <a-select-option mode="multiple" v-for="(option,x) in useroption" :key="x" :value="option.id">
                        {{option.name}}
                    </a-select-option>
                </a-select> -->

                <!-- 通话时长 -->
            </div>

            <div class="right">
                <a-input-search
                    placeholder="关键字（名称/手机）"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                   
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table  rowKey="smsid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
    
                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <span slot="status" slot-scope="text">
                        <!-- {{text}} -->
                        <a-tag v-if="text=='OK'" color="green">成功</a-tag>
                        <a-tag v-else color="orange">失败</a-tag>

                    </span>

                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>


    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import moment from 'moment'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
const columns = [
    {title: 'ID',dataIndex: 'smsid',key: 'smsid',width:80},
    {title: '手机',dataIndex: 'telephone',key: 'telephone',width:140},
    {title: '客户姓名',dataIndex: 'username',key: 'username',width:140},
    {title: '订单号',dataIndex: 'orderno',key: 'orderno',width:190},
    {title: '快递单号',dataIndex: 'tracknumber',key: 'tracknumber',width:230},
    {title: '发送状态',dataIndex: 'issuccess',key: 'issuccess',scopedSlots: { customRender: 'status' },width:160},
    {title: '发送时间',dataIndex: 'addtime',key: 'addtime',scopedSlots: { customRender: 'date' },width:220},
];
const data=[
    {id:'1',hjdate:"123",user:"123",name:"123",zphone:"123",bphone:"123",video:"12"}
]
export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd hh:mm:ss')
      }
    },
    data(){
        return{
            typeoption:[{id:"",name:'全部'},{id:1,name:'成功'},{id:2,name:'失败'}],
            locale,

            columns,
            data,
            tablespinning:true,
            pageSizeOptions:['10','20','30','40','100','200'],
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            addvisible:false,

            tablex:'',
            searchtext:"",

            endtime:"",
            starttime:"",

            issuccess:""
        }
    },
    mounted(){
        this.fetch()

    },
    methods:{
        typehandleChange(value){
            this.currentpage=1
            this.issuccess=value
            this.fetch()
        },

        // 日期范围
        ondateChange(date,dateString){
            this.currentpage=1
            this.starttime=moment(dateString[0]+' 00:00:01').unix()
            this.endtime=moment(dateString[1]+' 23:59:59').unix()
            this.fetch()
        },
        onSearch(){
            this.fetch()
        },

         // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 数据
        fetch(params = {}){
            this.$axios.post('/api/order/alismslog',{
                pagesize: this.size,
                page:this.currentpage,
                search:this.searchtext,
                starttime:this.starttime,
                endtime:this.endtime,
                issuccess:this.issuccess
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/order/msglog.vue